import React from 'react';
import {withRouter} from 'react-router-dom';

import './styles.css';

const DialogCard = (props) => {
   return <div className="dialog-wrapper">
      <div className="dialog-header">
         <h2 className={"m-0"}>{props.title}</h2>
      </div>
      <hr/>
      {props.children}
   </div>
};

export default withRouter(DialogCard);
